import { useObserva } from "@morganisbatman/observa-client-react";
import { Link } from "expo-router";
import { useEffect, useMemo } from "react";
import { StyleSheet, Text, View } from "react-native";

import { space, textStyle } from "@passfirst/ui";

import { Button } from "../../src/components/button";
import { Lockup } from "../../src/lockup";
import { type Colors, useColors } from "../../src/theme";

export default function CheckoutCancel(): JSX.Element {
  const observa = useObserva();
  const colors = useColors();
  const styles = useMemo(() => makeStyles(colors), [colors]);
  // Fires once on mount. Server-registered taxonomy validates the
  // payload at /_observability/trpc/events.record. Funnel work later
  // pairs this with `checkout.started` to surface drop-off rate.
  useEffect(() => {
    void observa.event({ eventType: "checkout.cancelled", payload: {} });
  }, [observa]);

  return (
    <View style={styles.outer}>
      <View style={styles.topBar}>
        <Lockup size={26} />
      </View>
      <View style={styles.container}>
        <Text style={styles.title}>Checkout cancelled</Text>
        <Text style={styles.subtitle}>No payment was taken.</Text>
        <Link href="/" asChild>
          <Button label="Back to home" />
        </Link>
      </View>
    </View>
  );
}

function makeStyles(colors: Colors) {
  return StyleSheet.create({
  outer: { flex: 1, backgroundColor: colors.background },
  topBar: {
    alignItems: "center",
    paddingTop: space[8],
    paddingBottom: space[2],
    borderBottomWidth: 1,
    borderBottomColor: colors.borderSoft,
  },
  container: {
    flex: 1,
    backgroundColor: colors.background,
    alignItems: "center",
    justifyContent: "center",
    padding: space[6],
    gap: space[4],
  },
  title: { ...textStyle.h2, color: colors.heading },
  subtitle: { ...textStyle.bodySmall, color: colors.textSecondary },
  });
}
